function sanityCheckHandler(all_arguments) {
    if(all_arguments.length > 3)
        throw new Error("Too many arguments for handler");
    if(!all_arguments[0])
         throw new Error("Key of handler undefined");
    if(!all_arguments[1])
        throw new Error("Function of handler undefined");
}

module.exports = sanityCheckHandler;
